import { ReglaBase } from './regla-base.model';

export class Mandato {

    id: number;
    nombre: string;
    palabrasClave: string[];
    padre: Mandato;
    hijos: Mandato[];
    politica: ReglaBase;
    descripcion: string;
    valor: Mandato;
    level: number;
    expandable: boolean;
    editable: boolean;

    /**
     * Constructor
     *
     * @param nodo
     */
    constructor(nodo)
    {
        {
            this.id = nodo.id || null;
            this.nombre = nodo.nombre || '';
            this.descripcion = nodo.descripcion || '';
            this.padre = nodo.padre || null;
            this.hijos = nodo.hijos || [];
            this.palabrasClave = nodo.palabrasClave || [];
            this.politica = nodo.politica || null;
        }
    }
}
